import { render, staticRenderFns } from "./saleWidget.vue?vue&type=template&id=6015e141"
import script from "./saleWidget.vue?vue&type=script&lang=js"
export * from "./saleWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports